var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPricing ||
    _vm.showTransactions ||
    _vm.showAccessories ||
    _vm.showPaymentMethod
    ? _c(
        "div",
        { staticClass: "ui zw subscription bottom active tab segment" },
        [
          _c("div", { staticClass: "topper" }, [
            _c("div", { staticClass: "text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.activeSubscription.product.name) +
                  "\n      "
              ),
              _vm.$store.getters.activeMerchant.kamstrup &&
              _vm.activeSubscription.product.category.water_meter
                ? _c(
                    "div",
                    { staticClass: "water_meter_block" },
                    [
                      _vm.activeSubscription.kamstrup_meters.length > 0
                        ? [
                            _vm._v("\n          ("),
                            _c(
                              "span",
                              {
                                staticClass: "water_meter_notice",
                                class:
                                  _vm.activeSubscription.status === "overdue"
                                    ? "overdue"
                                    : ""
                              },
                              [_vm._v(_vm._s(_vm.meterReadingNotice))]
                            ),
                            _vm._v(")\n        ")
                          ]
                        : [
                            _vm._v("\n          ("),
                            _c("span", { staticClass: "water_meter_notice" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pages.dashboard.details.kamstrup.payment.no_data"
                                  )
                                )
                              )
                            ]),
                            _vm._v(")\n        ")
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isDelayedSubscription
                ? _c("div", { staticClass: "delayed-block" }, [
                    _vm._v("\n        ("),
                    _c("span", { staticClass: "delayed" }, [
                      _vm._v(_vm._s(_vm.$t("globals.status.delayed")))
                    ]),
                    _vm._v(") -\n        "),
                    _c("span", { staticClass: "activation-date" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pages.dashboard.subscriptions.activation_on")
                        ) +
                          " " +
                          _vm._s(_vm.startDate)
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.activeSubscription.is_free
                ? _c("div", { staticStyle: { display: "inline-block" } }, [
                    _vm._v("\n        ("),
                    _c("span", { staticStyle: { color: "green" } }, [
                      _vm._v(_vm._s(_vm.$t("globals.status.free")))
                    ]),
                    _vm._v(")\n      ")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.canPayOverdueFee
              ? _c(
                  "button",
                  {
                    staticClass: "ui right floated blue button",
                    attrs: {
                      disabled:
                        _vm.isButtonDisabled ||
                        _vm.activeSubscription.overdue_fee_payed
                          ? "disabled"
                          : false
                    },
                    on: {
                      click: function($event) {
                        _vm.showPayOverdueFeeModal = !_vm.showPayOverdueFeeModal
                      }
                    }
                  },
                  [
                    _vm.activeSubscription.overdue_fee_payed
                      ? _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("globals.buttons.overdue_fee_paid")
                              ) +
                              "\n            "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("globals.buttons.pay_overdue_fee")
                              ) +
                              "\n            "
                          )
                        ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canPayOverdue
              ? _c(
                  "button",
                  {
                    staticClass: "ui right floated blue button",
                    attrs: {
                      disabled:
                        _vm.isButtonDisabled ||
                        (_vm.activeSubscription.apply_overdue_fee &&
                          _vm.activeSubscription.product.overdue_fee_amount !==
                            null &&
                          !_vm.activeSubscription.overdue_fee_payed)
                          ? "disabled"
                          : false
                    },
                    on: {
                      click: function($event) {
                        _vm.showPayOverdueModal = !_vm.showPayOverdueModal
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("globals.buttons.pay_overdue_payment")) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canChangePaymentMethod
              ? _c(
                  "div",
                  {
                    staticClass:
                      "ui right floated blue button change-payment-button",
                    on: {
                      click: function($event) {
                        _vm.showUpdatePaymentCardConfirmationModal = !_vm.showUpdatePaymentCardConfirmationModal
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("globals.buttons.change_card")) + "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canAddPaymentMethod
              ? _c(
                  "div",
                  {
                    staticClass:
                      "ui right floated blue button change-payment-button",
                    on: { click: _vm.openAddPaymentMethodModal }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("globals.buttons.add_payment_method")) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canBeCancelled
              ? _c(
                  "div",
                  {
                    staticClass: "ui right floated grey button",
                    on: {
                      click: function($event) {
                        _vm.showConfirmationModal = !_vm.showConfirmationModal
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("globals.buttons.cancel_subscription")) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.finalWaterPeriodPayment
            ? _c("div", { staticClass: "ui positive message" }, [
                _c("i", { staticClass: "check circle icon" }),
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _vm.$t(
                        "pages.dashboard.subscriptions.final_period_paid",
                        {
                          start: _vm.finalWaterPeriodPayment.period.start_date,
                          end: _vm.finalWaterPeriodPayment.period.end_date
                        }
                      )
                    ) +
                    "\n  "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ui information two column padded stackable grid" },
            [
              _c("div", { staticClass: "row" }, [
                _vm.showPricing
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "sixteen wide mobile seven wide tablet six wide computer column"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ui basic fluid zw flex segment" },
                          [
                            _c(
                              "div",
                              { staticClass: "ui divider horizontal header" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "pages.dashboard.subscriptions.paymentinterval"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ui zw one flex-center cards" },
                              [
                                _c("active-payment-plan", {
                                  attrs: {
                                    activeSubscription: _vm.activeSubscription
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showTransactions && !_vm.activeSubscription.is_free
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "sixteen wide mobile nine wide tablet ten wide computer column"
                      },
                      [
                        _c("div", { staticClass: "ui basic zw flex segment" }, [
                          _c(
                            "div",
                            { staticClass: "ui divider horizontal header" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pages.dashboard.subscriptions.upcomingtrans"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ui segments" },
                            [
                              _c("upcoming-transaction", {
                                attrs: {
                                  subscriptionid: _vm.activeSubscription.id
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm.processedTransactions.data.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "sixteen wide mobile nine wide tablet ten wide computer column"
                      },
                      [
                        _c("div", { staticClass: "ui basic zw flex segment" }, [
                          _c(
                            "div",
                            { staticClass: "ui divider horizontal header" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pages.dashboard.subscriptions.processedpayment"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ui segments" },
                            _vm._l(_vm.processedTransactions.data, function(
                              processedTransaction
                            ) {
                              return _c("transaction", {
                                key: processedTransaction.id,
                                attrs: {
                                  transaction: processedTransaction,
                                  amount: processedTransaction.amount
                                }
                              })
                            }),
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.showPaymentMethod
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "seven wide tablet six wide computer column"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ui divider horizontal header" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pages.dashboard.subscriptions.paymethod"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ui zw one cards" },
                          [
                            _vm.activeSubscription.payment_method === "nets" &&
                            _vm.activeSubscription.nets_details !== null
                              ? [
                                  _c("card", {
                                    staticClass: "centered",
                                    attrs: {
                                      card:
                                        _vm.activeSubscription.nets_details
                                          .payment_details
                                    }
                                  })
                                ]
                              : _vm.activeSubscription.payment_method ===
                                "mobile_pay"
                              ? [
                                  _c("card", {
                                    staticClass: "centered",
                                    attrs: {
                                      card: null,
                                      "card-type": "mobile_pay"
                                    }
                                  })
                                ]
                              : _vm.activeSubscription.payment_method ===
                                "vipps"
                              ? [
                                  _c("card", {
                                    staticClass: "centered",
                                    attrs: { card: null, "card-type": "vipps" }
                                  })
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showAccessories
                  ? _c(
                      "div",
                      {
                        staticClass: "nine wide tablet ten wide computer column"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ui divider horizontal header" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pages.dashboard.subscriptions.accessories"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ui zw flex-center cards" },
                          _vm._l(_vm.activeAccessories, function(accessory) {
                            return _c("accessory", {
                              key: accessory.id,
                              attrs: { accessory: accessory, changeable: false }
                            })
                          }),
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              ref: "modal",
              attrs: {
                active:
                  _vm.showUpdatePaymentCardModal && _vm.isOverdueChargedFailed,
                title: _vm.$t("modals.update_payment_card.title"),
                icons: "big alarm"
              },
              on: {
                acceptmodal: _vm.updatePaymentInformation,
                denymodal: _vm.closeUpdatePaymentCardModal
              }
            },
            [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("modals.update_payment_card.header")))
              ]),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("modals.update_payment_card.body"))
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm.activeSubscription.status === "overdue"
            ? _c(
                "semantic-modal",
                {
                  staticClass: "small",
                  attrs: {
                    active: _vm.showPayOverdueModal,
                    settings: {
                      content_classes: { content: false },
                      closeable: true,
                      closeable_button: true
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "header",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("h1", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("modals.overdue_payment_notice", {
                              amount: _vm.displayPricingAmount
                            })
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "actions",
                      attrs: { slot: "actions" },
                      slot: "actions"
                    },
                    [
                      _c("div", { staticClass: "ui deny button" }, [
                        _vm._v(_vm._s(_vm.$t("globals.buttons.no")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ui green ok button",
                          on: { click: _vm.payOverdue }
                        },
                        [_vm._v(_vm._s(_vm.$t("globals.buttons.yes")))]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeSubscription.status === "overdue"
            ? _c(
                "semantic-modal",
                {
                  staticClass: "small",
                  attrs: {
                    active: _vm.showPayOverdueFeeModal,
                    settings: {
                      content_classes: { content: false },
                      closeable: true,
                      closeable_button: true
                    }
                  }
                },
                [
                  _vm.activeSubscription.payment_method === "nets"
                    ? _c(
                        "div",
                        {
                          staticClass: "header",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _vm.activeSubscription.nets_details
                            .unscheduled_subscription_id
                            ? _c("h1", [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm.$t("modals.overdue_fee.unscheduled", {
                                        amount:
                                          _vm.activeSubscription.product
                                            .overdue_fee_amount
                                      })
                                    ) +
                                    "\n      "
                                )
                              ])
                            : _c("h1", [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(_vm.$t("modals.nets_notice")) +
                                    "\n      "
                                )
                              ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeSubscription.payment_method === "mobile_pay"
                    ? _c(
                        "div",
                        {
                          staticClass: "header",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c("h1", [
                            _vm._v(_vm._s(_vm.$t("modals.mobile_pay_notice")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeSubscription.payment_method === "vipps"
                    ? _c(
                        "div",
                        {
                          staticClass: "header",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c("h1", [
                            _vm._v(_vm._s(_vm.$t("modals.vipps_notice")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "actions",
                      attrs: { slot: "actions" },
                      slot: "actions"
                    },
                    [
                      _c("div", { staticClass: "ui deny button" }, [
                        _vm._v(_vm._s(_vm.$t("globals.buttons.no")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ui green ok button",
                          on: { click: _vm.payOverdueFee }
                        },
                        [_vm._v(_vm._s(_vm.$t("globals.buttons.yes")))]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "semantic-modal",
            {
              staticClass: "small",
              attrs: {
                active: _vm.showUpdatePaymentCardConfirmationModal,
                settings: {
                  content_classes: { content: false },
                  closeable: true,
                  closeable_button: true
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "header",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("h1", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pages.dashboard.subscriptions.validation.are_you_sure_change_card",
                          { product_name: _vm.activeSubscription.product.name }
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body-text" }, [
                _c("p", { staticClass: "modal-body-text__lead" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "pages.dashboard.subscriptions.validation.are_you_sure_change_card_body_text_lead",
                          { product_name: _vm.activeSubscription.product.name }
                        )
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-body-text__note" }, [
                  _c("i", {
                    staticClass:
                      "exclamation triangle icon modal-body-text__icon"
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pages.dashboard.subscriptions.validation.are_you_sure_change_card_body_text_note"
                        )
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "actions",
                  attrs: { slot: "actions" },
                  slot: "actions"
                },
                [
                  _c("div", { staticClass: "ui deny button" }, [
                    _vm._v(_vm._s(_vm.$t("globals.buttons.no")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ui red ok button",
                      on: { click: _vm.updatePaymentInformation }
                    },
                    [_vm._v(_vm._s(_vm.$t("globals.buttons.yes")))]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "semantic-modal",
            {
              staticClass: "medium",
              attrs: {
                settings: {
                  content_classes: { content: false },
                  closeable: true,
                  closeable_button: true
                }
              },
              model: {
                value: _vm.showAddPaymentMethodModal,
                callback: function($$v) {
                  _vm.showAddPaymentMethodModal = $$v
                },
                expression: "showAddPaymentMethodModal"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "header",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("h1", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pages.dashboard.subscriptions.add_payment_method.title"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body-text" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pages.dashboard.subscriptions.add_payment_method.description"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ui zw two flex-center stackable cards" },
                  _vm._l(_vm.availablePaymentMethods, function(paymentMethod) {
                    return _c("payment-method", {
                      key: paymentMethod.id,
                      attrs: {
                        id: paymentMethod.id,
                        name: paymentMethod.name,
                        slug: paymentMethod.slug,
                        active: _vm.selectedPaymentMethod === paymentMethod.slug
                      },
                      on: {
                        select: function($event) {
                          _vm.selectedPaymentMethod = $event
                        },
                        deselect: function($event) {
                          _vm.selectedPaymentMethod = null
                        }
                      }
                    })
                  }),
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "actions",
                  attrs: { slot: "actions" },
                  slot: "actions"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ui deny button",
                      on: {
                        click: function($event) {
                          _vm.showAddPaymentMethodModal = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("globals.buttons.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ui green button",
                      class: {
                        "loading disabled": _vm.isAddingPaymentMethod,
                        disabled: !_vm.selectedPaymentMethod
                      },
                      on: { click: _vm.addPaymentMethod }
                    },
                    [_vm._v(_vm._s(_vm.$t("globals.buttons.continue")))]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.activeSubscription.status === "active" ||
          _vm.activeSubscription.status === "delayed"
            ? _c(
                "semantic-modal",
                {
                  staticClass: "small",
                  attrs: {
                    active: _vm.showConfirmationModal,
                    settings: {
                      content_classes: { content: false },
                      closeable: true,
                      closeable_button: true
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "header",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("h1", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pages.dashboard.subscriptions.validation.are_you_sure"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "actions",
                      attrs: { slot: "actions" },
                      slot: "actions"
                    },
                    [
                      _c("div", { staticClass: "ui deny button" }, [
                        _vm._v(_vm._s(_vm.$t("globals.buttons.no")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ui red ok button",
                          on: { click: _vm.cancelSubscription }
                        },
                        [_vm._v(_vm._s(_vm.$t("globals.buttons.yes")))]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("loading", {
            attrs: { active: _vm.isLoading, "is-full-page": _vm.fullPage },
            on: {
              "update:active": function($event) {
                _vm.isLoading = $event
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-065c8170", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-065c8170","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/Subscriptions.vue
// module id = 0NIS
// module chunks = 1